export default __webpack_public_path__ + "static/media/app-icon.dcf147d7.png";